define('views/pages/claims/navbar',['require','views/base/view','text!templates/pages/claims/navbar.ejs','helpers/application','lib/utils','datepicker'],function(require) {
    'use strict';

    var View = require('views/base/view'),
        template = require('text!templates/pages/claims/navbar.ejs'),
        applicationHelper = require('helpers/application'),
        utils = require('lib/utils');

    require('datepicker');

    /*
        CLAIMS NAVBAR
    */

    var ClaimsNavbarView = View.extend({
        autoRender: true,
        className: 'navbar',
        template: template,
        listen: {
            'change:fromDate model': 'fromDateChange',
            'change:toDate model': 'toDateChange'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            this.delegate('click', '#loadData', this.loadData);
        },
        render: function() {
            View.prototype.render.apply(this, arguments);

            var _this = this;

            var $fd = this.$('#fromDate');
            var $td = this.$('#toDate');

            var fromDate = this.fromDate = $fd
                .datepicker({
                    format: 'dd.mm.yyyy',
                    weekStart: 1
                })
                .on('changeDate', function(ev) {
                    fromDate.hide();
                    _this.model.set('fromDate', ev.date);
                })
                .on('show', function() {
                    if (_this.model.get('loading')) {
                        fromDate.hide();
                    }
                })
                .data('datepicker');

            fromDate.setValue(this.model.get('fromDate'));

            var toDate = this.toDate = $td
                .datepicker({
                    format: 'dd.mm.yyyy',
                    weekStart: 1
                })
                .on('changeDate', function(ev) {
                    toDate.hide();
                    _this.model.set('toDate', ev.date);
                })
                .on('show', function() {
                    if (_this.model.get('loading')) {
                        toDate.hide();
                    }
                })
                .data('datepicker');

            toDate.setValue(this.model.get('toDate'));
        },
        dispose: function() {
            if (this.disposed) { return; }

            if (this.fromDate) {
                this.fromDate.picker.remove();
            }

            if (this.toDate) {
                this.toDate.picker.remove();
            }

            View.prototype.dispose.apply(this, arguments);
        },
        loadData: function() {
            applicationHelper.redirectTo('claims#show', { fromDate: utils.fmtDate(this.model.get('fromDate')), toDate: utils.fmtDate(this.model.get('toDate')) });
        },
        fromDateChange: function(model, date) {
            if (date.valueOf() > model.get('toDate').valueOf()) {
                var newDate = new Date(date);
                newDate.setDate(newDate.getDate() + 1);
                model.set('toDate', newDate);
            }

            if (this.fromDate) {
                this.fromDate.setValue(date);
            }
        },
        toDateChange: function(model, date) {
            if (date.valueOf() < model.get('fromDate').valueOf()) {
                var newDate = new Date(date);
                newDate.setDate(newDate.getDate() - 1);
                model.set('fromDate', newDate);
            }

            if (this.toDate) {
                this.toDate.setValue(date);
            }
        }
    });

    return ClaimsNavbarView;
});

